import { Link2, Brain, CheckCircle } from "lucide-react";

export default function HowItWorks() {
  const steps = [
    {
      icon: Link2,
      title: "Pega una URL de YouTube",
      description: "Simplemente copia el enlace del video que quieres analizar"
    },
    {
      icon: Brain,
      title: "La IA analiza el contenido",
      description: "Nuestro sistema procesa transcripción, metadatos y estructura narrativa"
    },
    {
      icon: CheckCircle,
      title: "Recibe recomendaciones accionables",
      description: "Obtén un informe detallado con oportunidades de mejora prioritizadas"
    }
  ];

  return (
    <section id="como-funciona" data-testid="how-it-works-section" className="py-20 bg-white scroll-mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Cómo Funciona
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Análisis profesional en menos de 60 segundos
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="relative">
                {/* Connection Line (hidden on mobile) */}
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-12 left-1/2 w-full h-0.5 bg-gradient-to-r from-purple-300 to-pink-300 z-0"></div>
                )}
                
                {/* Step Card */}
                <div className="relative z-10 text-center">
                  <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gradient-to-br from-purple-600 to-pink-600 text-white mb-6 shadow-lg">
                    <Icon className="w-12 h-12" />
                  </div>
                  <div className="absolute top-2 left-1/2 -translate-x-1/2 w-10 h-10 rounded-full bg-purple-100 text-purple-600 font-bold text-lg flex items-center justify-center">
                    {index + 1}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                  <p className="text-gray-600">{step.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
